import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

Vue.use(Router)
Vue.use(Meta)

import Users from '../components/Users'
import User from '../components/User'

import Logs from '../components/Logs'
import Log from '../components/Log'

import InputFields from "../components/InputFields"
import InputLanguage from "../components/InputLanguage"


export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      redirect: { name: 'users' }
    },
    {
      path: '/users',
      name: 'users',
      component: Users
    },
    {
      path: '/user/:userId',
      name: 'user',
      component: User
    },
    {
      path: '/logs',
      name: 'logs',
      component: Logs
    },
    {
      path: '/log/:logId',
      name: 'log',
      component: Log
    },
    {
      path: '/inputFields',
      name: 'inputFields',
      component: InputFields
    },
    {
      path: '/inputLanguage/:name',
      name: 'inputLanguage',
      component: InputLanguage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js